export enum SportTypes {
    Combat = "Combat",
    Timing = "Timing",
    Scoring = "Scoring",
    Racquet = "Racquet",
    Team = "Team",
    None = "None",
}
